import React from 'react';

export default function SVGThumbsDown(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width="25"
      height="25"
      viewBox="0 -3 50 47"
      fill="none"
      className="text-iconStrong fill-current"
    >
      <path
        d="M4.008 6.202C3.5 8.5 1.201 9.6 0 10v12c1.594 0 3.845.024 8.01.012h.104c3.905-.012 4.401-.013 4.897-1.512.5-1.512 1.295-4.172 1.615-6.893.32-2.722-2.513-3.602-4.126-3.602H8.01c.268-.467.801-2.322.801-4.403C8.811 3.001 8.511 0 6 0 4 0 4.57 3.662 4.008 6.202Z"
        stroke="none"
        strokeWidth={0}
        strokeDasharray={undefined}
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fillRule="nonzero"
        opacity={1}
        transform="rotate(180 17.346 23.289) scale(1.9602)"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M0 0h1.4A1.6 1.6 0 0 1 3 1.6v8.8A1.6 1.6 0 0 1 1.4 12H0V0Z"
        stroke="none"
        strokeWidth={0}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fillRule="nonzero"
        opacity={1}
        transform="rotate(180 22.014 13.473) scale(1.9602)"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
